/* fk.js — Zood v51 fix */
(function () {
  'use strict';
  var S    = window.fkShop || {};
  var AR   = (S.locale === 'ar');
  var HOME = S.homeUrl || '/';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var TX = {
    topbar1:   { en: '\u{1F4E6} Free delivery on orders above 5.000 KWD', ar: '\u{1F4E6} \u062A\u0648\u0635\u064A\u0644 \u0645\u062C\u0627\u0646\u064A \u0641\u0648\u0642 5.000 \u062F\u0643' },
    topbar2:   { en: '\u{1F1F0}\u{1F1FC} Kuwait Nationwide', ar: '\u{1F1F0}\u{1F1FC} \u062A\u0648\u0635\u064A\u0644 \u0644\u062C\u0645\u064A\u0639 \u0645\u062D\u0627\u0641\u0638\u0627\u062A \u0627\u0644\u0643\u0648\u064A\u062A' },
    search:    { en: 'Search',            ar: '\u0628\u062D\u062B' },
    searchPh:  { en: 'Search products...', ar: '\u0627\u0628\u062D\u062B \u0639\u0646 \u0645\u0646\u062A\u062C...' },
    premium:   { en: 'Need it? Zood it', ar: '\u0643\u0644 \u0645\u0627 \u062A\u062D\u062A\u0627\u062C' },
    home:      { en: 'Home',              ar: '\u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629' },
    allTag:    { en: 'All',               ar: '\u0627\u0644\u0643\u0644' },
    cartTitle: { en: 'Your Cart',         ar: '\u0633\u0644\u0629 \u0627\u0644\u062A\u0633\u0648\u0642' },
    added:     { en: 'Added to cart',     ar: '\u062A\u0645\u062A \u0627\u0644\u0625\u0636\u0627\u0641\u0629' },
    empty:     { en: 'Your cart is empty', ar: '\u0633\u0644\u062A\u0643 \u0641\u0627\u0631\u063A\u0629' },
    total:     { en: 'Estimated total',   ar: '\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u062A\u0642\u062F\u064A\u0631\u064A' },
    tax:       { en: 'Taxes and shipping calculated at checkout', ar: '\u064A\u062A\u0645 \u062D\u0633\u0627\u0628 \u0627\u0644\u0636\u0631\u0627\u0626\u0628 \u0648\u0627\u0644\u0634\u062D\u0646 \u0639\u0646\u062F \u0627\u0644\u062F\u0641\u0639' },
    checkout:  { en: 'Check out',         ar: '\u0625\u062A\u0645\u0627\u0645 \u0627\u0644\u0634\u0631\u0627\u0621' },
    cont:      { en: 'Continue shopping', ar: '\u0645\u0648\u0627\u0635\u0644\u0629 \u0627\u0644\u062A\u0633\u0648\u0642' },
    remove:    { en: 'Remove',            ar: '\u062D\u0630\u0641' }
  };
  function t(k) { return AR ? TX[k].ar : TX[k].en; }
  function money(c) { return (c / 100).toFixed(3) + ' KWD'; }
  function esc(s) { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function thumb(u, w) { if (!u) return u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 160); }
  function isTouch() { return window.matchMedia('(hover:none)').matches; }
  function loc(url) {
    var p; try { p = new URL(url, location.origin).pathname + (new URL(url, location.origin).search || ''); } catch(e) { p = url; }
    if (p.startsWith('/ar/') || p === '/ar') return p;
    if (AR) return '/ar' + (p.startsWith('/') ? p : '/' + p);
    return p;
  }
  function handleFromUrl(url) {
    try { var p = new URL(url, location.origin).pathname; var m = p.match(/\/collections\/([^\/\?]+)/); return m ? m[1] : null; } catch(e) { return null; }
  }
  function tagUrl(colUrl, enTag) {
    var base = loc(colUrl).replace(/\/+$/, '');
    return base + '/' + enTag.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  var IC = {
    menu:    '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="3" y1="5" x2="21" y2="5"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="19" x2="21" y2="19"/></svg>',
    chevron: '<svg viewBox="0 0 24 24" width="10" height="10" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6,9 12,15 18,9"/></svg>',
    x:     '<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
    minus: '<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="2.5" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/></svg>',
    plus:  '<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>',
    lock:  '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
    trash: '<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="2" stroke-linecap="round"><polyline points="3,6 5,6 21,6"/><path d="M19,6l-1,14a2,2,0,0,1-2,2H8a2,2,0,0,1-2-2L5,6"/><path d="M10,11v6"/><path d="M14,11v6"/><path d="M9,6V4h6v2"/></svg>',
    cart:  '<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="1.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>',
    cartW: '<svg viewBox="0 0 24 24" stroke="#fff" fill="none" stroke-width="1.5"><circle cx="9" cy="21" r="1" stroke="#fff"/><circle cx="20" cy="21" r="1" stroke="#fff"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>',
    up:    '<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="18,15 12,9 6,15"/></svg>',
    check: '<svg viewBox="0 0 24 24" stroke="#fff" fill="none" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20,6 9,17 4,12"/></svg>',
    searchIc: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>'
  };
  if (AR) { document.documentElement.dir='rtl'; document.documentElement.lang='ar'; }
  function badge(n) {
    var el=document.getElementById('fk-badge'); if(!el) return;
    el.textContent=n; el.classList.remove('pop'); void el.offsetWidth; el.classList.add('pop');
    setTimeout(function(){ el.classList.remove('pop'); }, 450);
  }
  var _toastTimer;
  function showToast(productTitle, imgUrl) {
    var existing = document.getElementById('fk-toast');
    if (existing) existing.parentNode.removeChild(existing);
    clearTimeout(_toastTimer);
    var toast = document.createElement('div'); toast.id = 'fk-toast';
    toast.innerHTML = (imgUrl ? '<img class="fk-toast-img" src="'+esc(thumb(imgUrl,120))+'" alt="">' : '<div class="fk-toast-icon">'+IC.check+'</div>') +
      '<div class="fk-toast-text"><span class="fk-toast-label">'+t('added')+'</span><span class="fk-toast-name">'+esc(productTitle||'')+'</span></div>';
    document.body.appendChild(toast);
    requestAnimationFrame(function(){ toast.classList.add('show'); });
    _toastTimer = setTimeout(function() {
      toast.classList.remove('show'); toast.classList.add('hide');
      setTimeout(function(){ if(toast.parentNode) toast.parentNode.removeChild(toast); }, 250);
    }, 2500);
  }
  function scrollToActive(activeEl, container) {
    if (!activeEl || !container) return;
    try { activeEl.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'instant' }); }
    catch(e) { container.scrollLeft = activeEl.offsetLeft - (container.offsetWidth / 2) + (activeEl.offsetWidth / 2); }
  }
  var _portal=null,_bridge=null,_activeWrap=null,_closeTimer=null,_portalTouching=false;
  function _clearClose() { if (_closeTimer) { clearTimeout(_closeTimer); _closeTimer = null; } }
  function portalClose(immediate) {
    _clearClose();
    function doClose() {
      if (_portal && _portal.parentNode) _portal.parentNode.removeChild(_portal);
      if (_bridge && _bridge.parentNode) _bridge.parentNode.removeChild(_bridge);
      _portal=null;_bridge=null;_activeWrap=null;_portalTouching=false;
    }
    if (immediate) { doClose(); } else { _closeTimer = setTimeout(doClose, 300); }
  }
  function portalOpen(wrap, html) {
    _clearClose();
    if (_activeWrap === wrap && _portal) return;
    if (_portal && _portal.parentNode) _portal.parentNode.removeChild(_portal);
    if (_bridge && _bridge.parentNode) _bridge.parentNode.removeChild(_bridge);
    var rect=wrap.getBoundingClientRect(), GAP=4;
    var portal=document.createElement('div'); portal.className='fk-pdrop-portal'; portal.innerHTML=html;
    document.body.appendChild(portal);
    var left=rect.left, top=rect.bottom+GAP;
    portal.style.left=left+'px'; portal.style.top=top+'px';
    var avail=window.innerHeight-top-12; if(avail<160) avail=160;
    portal.style.maxHeight=avail+'px';
    var pw=portal.offsetWidth||220;
    if(left+pw>window.innerWidth-8){left=Math.max(8,window.innerWidth-pw-8);portal.style.left=left+'px';}
    var bridge=document.createElement('div');
    bridge.style.cssText='position:fixed;z-index:9996;background:transparent;';
    bridge.style.left=Math.min(rect.left,left)+'px'; bridge.style.top=rect.bottom+'px';
    bridge.style.width=Math.max(rect.width,pw)+'px'; bridge.style.height=GAP+'px';
    document.body.appendChild(bridge);
    _portal=portal;_bridge=bridge;_activeWrap=wrap;_portalTouching=false;
    portal.addEventListener('touchstart',function(){_portalTouching=true;},{passive:true});
    portal.addEventListener('touchend',function(){_portalTouching=false;},{passive:true});
    portal.addEventListener('touchcancel',function(){_portalTouching=false;},{passive:true});
    [portal,bridge].forEach(function(el){
      el.addEventListener('mouseenter',_clearClose);
      el.addEventListener('mouseleave',function(){if(isTouch())return;portalClose(false);});
    });
    requestAnimationFrame(function(){portal.classList.add('open');});
  }
  window.addEventListener('scroll',function(e){
    if(_portalTouching)return;
    if(_portal&&e.target&&e.target.nodeType===1&&_portal.contains(e.target))return;
    portalClose(true);
  },{passive:true,capture:true});
  function buildHeader() {
    var logo = S.logo ? '<img class="fk-logo-img" src="'+S.logo+'" alt="'+esc(S.name||'')+'">' : '<div class="fk-logo-box">Z</div>';
    var wordmark =
      '<span style="font-family:\'Poppins\',sans-serif;font-weight:800;color:#6EC2FF;letter-spacing:.02em;font-size:1.05rem;">ZOOD</span>'+
      '<span style="color:#CBD5E1;margin:0 .28rem;font-weight:300;font-size:1rem;">|</span>'+
      '<span style="font-family:\'Cairo\',sans-serif;font-weight:800;color:#6EC2FF;font-size:1.05rem;">\u0632\u0648\u062F</span>';
    var tb=document.getElementById('fk-topbar');
    if(tb) tb.innerHTML='<div class="fk-tb-left"><span>'+t('topbar2')+'</span></div><div class="fk-tb-right"><span>'+t('topbar1')+'</span></div>';
    var nav=document.getElementById('fk-nav'), acctWrap=document.getElementById('fk-acct-wrap');
    if(nav){
      nav.innerHTML=
        '<a href="'+HOME+'" class="fk-logo">'+logo+'<div class="fk-logo-info"><span class="fk-logo-name">'+wordmark+'</span><span class="fk-logo-sub">'+t('premium')+'</span></div></a>'+
        '<div class="fk-search"><input type="text" id="fk-si" placeholder="'+t('searchPh')+'" aria-label="'+t('search')+'"><button class="fk-search-btn" id="fk-sbtn" aria-label="'+t('search')+'">'+IC.searchIc+'</button></div>'+
        '<div class="fk-nav-btns" id="fk-nav-btns"><button type="button" class="fk-nbtn fk-nbtn-cart fk-icon-only" id="fk-cart-btn" aria-label="Cart">'+IC.cartW+'<span class="fk-cart-n" id="fk-badge">0</span></button></div>';
      var btnRow=document.getElementById('fk-nav-btns');
      if(btnRow&&acctWrap){acctWrap.style.display='inline-flex';acctWrap.style.alignItems='center';btnRow.insertBefore(acctWrap,btnRow.firstChild);}
    }
    buildPills();
    var si=document.getElementById('fk-si'),sb=document.getElementById('fk-sbtn');
    function search(){var q=(si?si.value:'').trim();if(q)location.href=(S.searchUrl||'/search')+'?type=product&q='+encodeURIComponent(q);}
    if(sb)sb.addEventListener('click',search);
    if(si)si.addEventListener('keydown',function(e){if(e.key==='Enter')search();});
    var cb=document.getElementById('fk-cart-btn');
    if(cb)cb.addEventListener('click',cartOpen);
    fetch(ROOT+'cart.js').then(function(r){return r.json();}).then(function(c){cartRender(c);}).catch(function(){});
  }
  function buildPills() {
    var p=document.getElementById('fk-pills'); if(!p) return;
    var pathname=location.pathname,links=S.navLinks||[],collectionTags=S.collectionTags||{};
    var drops=links.map(function(l){return '<a href="'+loc(l.url)+'">'+esc(l.title)+'</a>';}).join('');
    var html='<div class="fk-shopall-wrap" id="fk-saw"><button type="button" class="fk-shopall-btn" id="fk-sab">'+IC.menu+'</button><div class="fk-shopall-drop" id="fk-sad">'+drops+'</div></div><div class="fk-pills-scroll" id="fk-ps">';
    var ha=(pathname==='/'||pathname===HOME||pathname==='/ar/'||pathname==='/ar')?' fk-pill-on':'';
    html+='<a href="'+HOME+'" class="fk-pill'+ha+'">&#127968; '+t('home')+'</a>';
    links.forEach(function(l){
      var path=loc(l.url),pb=path.replace(/^\/ar/,''),lb=pathname.replace(/^\/ar/,'');
      var isActive=(lb===pb||lb.indexOf(pb)===0)&&pb!=='/',on=isActive?' fk-pill-on':'';
      var colHandle=handleFromUrl(l.url),tagData=colHandle&&collectionTags[colHandle];
      if(tagData&&tagData.tags&&tagData.tags.length>0){
        var tagHtml='<a href="'+loc(tagData.url)+'" class="fk-pdrop-item">'+t('allTag')+' '+esc(l.title)+'</a>';
        var tagsAr=(AR&&tagData.tagsAr&&tagData.tagsAr.length)?tagData.tagsAr:[];
        tagData.tags.forEach(function(enTag,i){
          var trimmedEn=enTag.trim(); if(!trimmedEn)return;
          var displayLabel=(tagsAr[i]&&tagsAr[i].trim())?tagsAr[i].trim():trimmedEn;
          var href=tagUrl(tagData.url,trimmedEn);
          var tagSlug=trimmedEn.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
          var tagActive=lb===pb+'/'+tagSlug?' fk-pdrop-on':'';
          tagHtml+='<a href="'+href+'" class="fk-pdrop-item'+tagActive+'">'+esc(displayLabel)+'</a>';
        });
        html+='<div class="fk-pill-wrap" data-tag-html="'+esc(tagHtml)+'"><a href="'+path+'" class="fk-pill'+on+'">'+esc(l.title)+' <span class="fk-pill-chevron">'+IC.chevron+'</span></a></div>';
      } else { html+='<a href="'+path+'" class="fk-pill'+on+'">'+esc(l.title)+'</a>'; }
    });
    p.innerHTML=html+'</div>';
    var scrollWrap=document.getElementById('fk-ps');
    scrollToActive(scrollWrap?scrollWrap.querySelector('.fk-pill-on'):null,scrollWrap);
    var sab=document.getElementById('fk-sab'),sad=document.getElementById('fk-sad');
    if(sab&&sad){
      sab.addEventListener('click',function(e){e.stopPropagation();sad.classList.toggle('open');});
      document.addEventListener('click',function(){if(sad)sad.classList.remove('open');});
      sad.addEventListener('click',function(e){e.stopPropagation();});
    }
    p.querySelectorAll('.fk-pill-wrap[data-tag-html]').forEach(function(wrap){
      var rawHtml=wrap.getAttribute('data-tag-html').replace(/&amp;/g,'&').replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&quot;/g,'"');
      function setChev(open) {
        var chev = wrap.querySelector('.fk-pill-chevron');
        if (chev) chev.style.transform = open ? 'rotate(180deg)' : '';
      }
      wrap.addEventListener('mouseenter',function(){if(isTouch())return;portalOpen(wrap,rawHtml);setChev(true);});
      wrap.addEventListener('mouseleave',function(){if(isTouch())return;_closeTimer=setTimeout(function(){if(_activeWrap===wrap)portalClose(false);},80);setChev(false);});
      var pill=wrap.querySelector('.fk-pill');
      if(pill){
        pill.addEventListener('click',function(e){
          if(!isTouch())return;
          var isOpen=(_activeWrap===wrap&&_portal);
          if(e.target.closest&&e.target.closest('.fk-pill-chevron')){e.preventDefault();if(isOpen){portalClose(true);setChev(false);}else{portalOpen(wrap,rawHtml);setChev(true);}return;}
          if(isOpen){portalClose(true);setChev(false);return;}e.preventDefault();portalOpen(wrap,rawHtml);setChev(true);
        });
      }
    });
    document.addEventListener('click',function(e){if(_portal&&!e.target.closest('.fk-pdrop-portal')&&!e.target.closest('.fk-pill-wrap'))portalClose(true);});
  }
  var BUSY=false,OPEN=false,lastCart=null;
  function cartBuild(){
    var ov=document.getElementById('fk-cart-overlay'),dr=document.getElementById('fk-cart-drawer');
    if(!dr)return;
    if(ov)ov.addEventListener('click',cartClose);
    dr.innerHTML=
      '<div class="fk-dh"><div class="fk-dh-l"><div class="fk-dh-icon">'+IC.cartW+'</div><span class="fk-dh-title">'+t('cartTitle')+'</span><div class="fk-dh-count" id="fk-dc">0</div></div><button type="button" class="fk-close" id="fk-cls">'+IC.x+'</button></div>'+
      '<div class="fk-db" id="fk-db"><div class="fk-empty-cart">'+IC.cart+'<span>'+t('empty')+'</span></div></div>'+
      '<div class="fk-dfooter" id="fk-df" style="display:none"><div class="fk-total-row"><span class="fk-total-lbl">'+t('total')+'</span><span class="fk-total-val" id="fk-tv">0.000 KWD</span></div><div class="fk-divider"></div><span class="fk-tax-note">'+t('tax')+'</span><button type="button" class="fk-checkout-btn" id="fk-co">'+IC.lock+' '+t('checkout')+'</button><button type="button" class="fk-continue-btn" id="fk-cont">'+t('cont')+'</button></div>';
    document.getElementById('fk-cls').addEventListener('click',cartClose);
    document.getElementById('fk-cont').addEventListener('click',cartClose);
    document.getElementById('fk-co').addEventListener('click',function(){window.location.href=ROOT+'checkout';});
    dr.addEventListener('click',function(e){
      if(BUSY)return;
      var qb=e.target.closest('[data-k][data-q]');
      if(qb){e.preventDefault();e.stopPropagation();var newQ=Math.max(0,parseInt(qb.getAttribute('data-q'),10));var rowEl=qb.closest('.fk-item');if(rowEl){var qv=rowEl.querySelector('.fk-qv');if(qv)qv.textContent=newQ;if(newQ===0)rowEl.style.opacity='.35';}cartChange(qb.getAttribute('data-k'),newQ);return;}
      var rb=e.target.closest('[data-k][data-r]');
      if(rb){e.preventDefault();e.stopPropagation();var rmRow=rb.closest('.fk-item');if(rmRow)rmRow.style.opacity='.35';cartChange(rb.getAttribute('data-k'),0);}
    });
  }
  function cartOpen(){if(OPEN)return;OPEN=true;var ov=document.getElementById('fk-cart-overlay'),dr=document.getElementById('fk-cart-drawer');if(ov)ov.classList.add('on');if(dr)dr.classList.add('on');document.body.style.overflow='hidden';if(lastCart)cartRender(lastCart);cartFetch();}
  function cartClose(){OPEN=false;var ov=document.getElementById('fk-cart-overlay'),dr=document.getElementById('fk-cart-drawer');if(ov)ov.classList.remove('on');if(dr)dr.classList.remove('on');document.body.style.overflow='';}
  function cartFetch(){fetch(ROOT+'cart.js').then(function(r){if(!r.ok)throw new Error(r.status);return r.json();}).then(cartRender).catch(function(err){console.error('[fk]',err);});}
  function cartChange(key,qty){BUSY=true;fetch(ROOT+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){if(!r.ok)throw new Error('change '+r.status);return r.json();}).then(function(cart){BUSY=false;cartRender(cart);}).catch(function(err){BUSY=false;console.error('[fk]',err);cartFetch();});}
  function cartRender(cart){
    lastCart=cart;
    var db=document.getElementById('fk-db'),df=document.getElementById('fk-df'),dc=document.getElementById('fk-dc'),tv=document.getElementById('fk-tv');
    badge(cart.item_count);if(dc)dc.textContent=cart.item_count;if(!db)return;
    var items=(cart.items||[]).filter(function(it){return it.quantity>0;});
    if(!items.length){db.innerHTML='<div class="fk-empty-cart">'+IC.cart+'<span>'+t('empty')+'</span></div>';if(df)df.style.display='none';return;}
    if(df)df.style.display='block';if(tv)tv.textContent=money(cart.total_price);
    var html='';
    items.forEach(function(item){
      var k=item.key;
      var img=item.image?'<img src="'+esc(thumb(item.image,160))+'" alt="'+esc(item.title)+'" loading="lazy">':'<span>&#128722;</span>';
      html+='<div class="fk-item"><div class="fk-iimg">'+img+'</div><div class="fk-idet">'+(item.product_type?'<div class="fk-itype">'+esc(item.product_type)+'</div>':'')+'<div class="fk-iname">'+esc(item.title)+'</div>'+(item.variant_title&&item.variant_title!=='Default Title'?'<div class="fk-ivar">'+esc(item.variant_title)+'</div>':'')+'<div class="fk-ifoot"><span class="fk-iprice">'+money(item.final_line_price)+'</span><div class="fk-iact"><div class="fk-qty"><button type="button" class="fk-qb" data-k="'+esc(k)+'" data-q="'+(item.quantity-1)+'">'+IC.minus+'</button><span class="fk-qv">'+item.quantity+'</span><button type="button" class="fk-qb" data-k="'+esc(k)+'" data-q="'+(item.quantity+1)+'">'+IC.plus+'</button></div><button type="button" class="fk-rm" data-k="'+esc(k)+'" data-r="1">'+IC.trash+' <span>'+t('remove')+'</span></button></div></div></div></div>';
    });
    db.innerHTML=html;
  }
  function buildScrollTop(){
    var btn=document.createElement('button');btn.type='button';btn.id='fk-scroll-top';btn.setAttribute('aria-label','Scroll to top');btn.innerHTML=IC.up;
    document.body.appendChild(btn);
    window.addEventListener('scroll',function(){btn.classList.toggle('visible',window.scrollY>400);},{passive:true});
    btn.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'});});
  }
  var cardState={};
  function cardSetState(wrap,qty){
    var addBtn=wrap.querySelector('.fk-cadd'),qCtrl=wrap.querySelector('.fk-card-qty'),qVal=wrap.querySelector('.fk-cq-val');
    var vid=addBtn?addBtn.getAttribute('data-variant-id'):(qCtrl?qCtrl.getAttribute('data-vid'):null);
    if(qty<=0){if(qCtrl)qCtrl.classList.remove('open');if(addBtn){addBtn.style.display='flex';addBtn.disabled=false;}if(vid)delete cardState[vid];}
    else{if(addBtn)addBtn.style.display='none';if(qCtrl)qCtrl.classList.add('open');if(qVal)qVal.textContent=qty;if(vid&&cardState[vid])cardState[vid].qty=qty;}
  }
  function getBadgeCount(){var el=document.getElementById('fk-badge');return el?(parseInt(el.textContent,10)||0):0;}
  document.addEventListener('click',function(e){
    if(e.target.closest('#fk-cart-drawer'))return;
    var addBtn=e.target.closest('.fk-cadd[data-variant-id]');
    if(addBtn){
      e.preventDefault();
      var wrap=addBtn.closest('.fk-cadd-wrap'),vid=addBtn.getAttribute('data-variant-id');
      if(!vid||!wrap)return;
      addBtn.style.display='none';
      var qCtrl=wrap.querySelector('.fk-card-qty'),qVal=wrap.querySelector('.fk-cq-val');
      if(qCtrl)qCtrl.classList.add('open');if(qVal)qVal.textContent='1';
      badge(getBadgeCount()+1);
      var card=wrap.closest('.fk-card,.fk-ccard,a[class*="card"]');
      var imgEl=card?card.querySelector('img'):null,nameEl=card?card.querySelector('.fk-cname,.fk-name,[class*="name"]'):null;
      var productTitle=nameEl?nameEl.textContent.trim():'',productImg=imgEl?imgEl.src:'';
      fetch(ROOT+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:parseInt(vid,10),quantity:1}]})})
      .then(function(r){if(!r.ok)throw new Error(r.status);return r.json();})
      .then(function(res){
        var key=res.items&&res.items[0]?res.items[0].key:null;
        cardState[vid]={qty:1,key:key};
        var item=res.items&&res.items[0];
        showToast(item?item.title:productTitle,item&&item.image?item.image:productImg);
        fetch(ROOT+'cart.js').then(function(r2){return r2.json();}).then(function(c){cartRender(c);}).catch(function(){});
      })
      .catch(function(err){console.error('[fk] add:',err);addBtn.style.display='flex';if(qCtrl)qCtrl.classList.remove('open');badge(getBadgeCount()-1);});
      return;
    }
    var qbtn=e.target.closest('.fk-cq-btn');
    if(qbtn){
      e.preventDefault();
      var wrap2=qbtn.closest('.fk-cadd-wrap'),qCtrl2=qbtn.closest('.fk-card-qty');
      var vid2=qCtrl2?qCtrl2.getAttribute('data-vid'):null;
      if(!vid2||!wrap2)return;
      var state=cardState[vid2]||{qty:1,key:null};
      var action=qbtn.getAttribute('data-action'),curr=state.qty;
      var newQty=action==='plus'?curr+1:curr-1,key=state.key;
      cardSetState(wrap2,newQty);badge(getBadgeCount()+(action==='plus'?1:-1));
      if(!key){
        fetch(ROOT+'cart.js').then(function(r){return r.json();}).then(function(cart){
          var item=(cart.items||[]).find(function(i){return String(i.variant_id)===String(vid2);});
          if(!item){cardSetState(wrap2,curr);badge(getBadgeCount()+(action==='plus'?-1:1));return;}
          cardState[vid2]={qty:newQty,key:item.key};doChange(item.key,newQty,vid2,wrap2,curr,action);
        }).catch(function(err){console.error('[fk] key lookup:',err);cardSetState(wrap2,curr);});
        return;
      }
      doChange(key,newQty,vid2,wrap2,curr,action);
    }
  },true);
  function doChange(key,newQty,vid,wrap,rollbackQty,action){
    fetch(ROOT+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:newQty})})
    .then(function(r){if(!r.ok)throw new Error(r.status);return r.json();})
    .then(function(cart){
      cartRender(cart);
      var item=(cart.items||[]).find(function(i){return String(i.variant_id)===String(vid);});
      if(item&&cardState[vid])cardState[vid].key=item.key;
    })
    .catch(function(err){console.error('[fk] change:',err);cardSetState(wrap,rollbackQty);badge(getBadgeCount()+(action==='plus'?-1:1));});
  }
  buildHeader();cartBuild();buildScrollTop();
  window.fkCart={open:cartOpen,close:cartClose};
  window.fkUI={refreshPills:buildPills};
}());
